import { archRententionOption } from '../../Question';
import { questions } from '../../Question';

export const getClearRetainerDesignOptDisplayLabel = (opt = '') => {
    if (!opt || !opt.length) return '-';
    const found = archRententionOption.find((item) => item.value === opt);
    if (found) return found.label;
    return '-';
};
export const initQuestionList = [
    // {
    //     question : questions[1].question,
    //     field : questions[1].name
    // },
    {
        question: questions[2].question,
        field: questions[2].name,
        option: null,
    },
    {
        question: questions[3].question,
        field: questions[3].name,
        option: null,
    },
    {
        question: questions[4].question,
        field: questions[4].name,
        option: null,
    },
    {
        question: questions['5A'].question,
        field: questions['5A'].name,
        option: 'Upper',
    },
    {
        question: questions['5B'].question,
        field: questions['5B'].name,
        option: 'Lower',
    },
    // {
    //     question : questions['6A'].question,
    //     field : questions['6A'].name,
    //     option : "Upper"
    // },
    // {
    //     question : questions['6B'].question,
    //     field : questions['6B'].name,
    //     option : 'Lower'
    // },
    {
        question: questions[7].question,
        field: questions[7].name,
        option: null,
    },
    // {
    //     question : questions[8].question,
    //     field : questions[8].name
    // },
];

export const getValueKey = (field = '') => {
    switch (field) {
        // archPosition
        // case questions[1].name:
        //     break;
        // fixedWire
        case questions[2].name:
            return 'FixedWire';
        // archAndQuantity
        case questions[3].name:
            return 'RetainerTypeId';
        // occlusalBiteRampQuestion
        case questions[4].name:
            return 'BiteRamp';
        // clearRetainerDesignUpper
        case questions['5A'].name:
            return 'ClearRetainerDesignUpperOption';
        // clearRetainerDesignLower
        case questions['5B'].name:
            return 'ClearRetainerDesignLowerOption';
        // clearRetainerDesignUpperForSecondSet
        // case questions['6A'].name:
        //     return 'ClearRetainerDesignUpperOptionForSecondSet'
        // clearRetainerDesignLowerForSecondSet
        // case questions['6B'].name:
        //     return 'ClearRetainerDesignLowerOptionForSecondSet'
        // pontics
        case questions[7].name:
            return 'Pontics';
        case 'pontic':
            return 'Pontic';
        case 'ponticColor':
            return 'PonticColor';
        default:
            return '';
    }
};

export const SUMMARY_TEETH = {
    topRight: {
        maxX: 400,
        maxY: 58,
        minX: 30,
        minY: 5,
        values: [
            { value: 0, positionX: 59, positionY: 33, boundX: 90 },
            { value: 1, positionX: 117, positionY: 33, boundX: 145 },
            { value: 2, positionX: 172, positionY: 33, boundX: 200 },
            { value: 3, positionX: 226, positionY: 33, boundX: 250 },
            { value: 4, positionX: 272, positionY: 33, boundX: 295 },
            { value: 5, positionX: 313, positionY: 33, boundX: 335 },
            { value: 6, positionX: 350, positionY: 33, boundX: 370 },
            { value: 7, positionX: 386, positionY: 33, boundX: 405 },
        ],
    },
    topLeft: {
        maxX: 780,
        maxY: 58,
        minX: 405,
        minY: 5,
        values: [
            { value: 8, positionX: 424, positionY: 33, boundX: 440 },
            { value: 9, positionX: 458, positionY: 33, boundX: 447 },
            { value: 10, positionX: 494, positionY: 33, boundX: 514 },
            { value: 11, positionX: 536, positionY: 33, boundX: 559 },
            { value: 12, positionX: 581, positionY: 33, boundX: 605 },
            { value: 13, positionX: 631, positionY: 33, boundX: 662 },
            { value: 14, positionX: 690, positionY: 33, boundX: 719 },
            { value: 15, positionX: 746, positionY: 33, boundX: 773 },
        ],
    },
    bottomRight: {
        maxX: 400,
        maxY: 170,
        minX: 30,
        minY: 125,
        values: [
            { value: 16, positionX: 60, positionY: 148, boundX: 90 },
            { value: 17, positionX: 120, positionY: 148, boundX: 145 },
            { value: 18, positionX: 174, positionY: 148, boundX: 200 },
            { value: 19, positionX: 224, positionY: 148, boundX: 250 },
            { value: 20, positionX: 272, positionY: 148, boundX: 295 },
            { value: 21, positionX: 314, positionY: 148, boundX: 335 },
            { value: 22, positionX: 348, positionY: 148, boundX: 370 },
            { value: 23, positionX: 386, positionY: 148, boundX: 405 },
        ],
    },
    bottomLeft: {
        maxX: 780,
        maxY: 170,
        minX: 405,
        minY: 125,
        values: [
            { value: 24, positionX: 420, positionY: 148, boundX: 440 },
            { value: 25, positionX: 456, positionY: 148, boundX: 447 },
            { value: 26, positionX: 493, positionY: 148, boundX: 514 },
            { value: 27, positionX: 535, positionY: 148, boundX: 559 },
            { value: 28, positionX: 582, positionY: 148, boundX: 605 },
            { value: 29, positionX: 632, positionY: 148, boundX: 662 },
            { value: 30, positionX: 690, positionY: 148, boundX: 719 },
            { value: 31, positionX: 745, positionY: 148, boundX: 773 },
        ],
    },
};
